import React, { useMemo, useRef, useEffect,useState } from 'react';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import Modal from 'react-bootstrap/Modal';
import MsgUtils from '../Tools/MsgUtils';


const datosIniciales = [
    { idSucursal: 2, sucursal: 'SAN MARTIN 1', vegetal: [0,0,0,0,0], hidrogenado: [0,0,0,0,0] },
    { idSucursal: 3, sucursal: 'SAN MARTIN 2', vegetal: [0,0,0,0,0], hidrogenado: [0,0,0,0,0] },
    { idSucursal: 6, sucursal: 'VILLARROEL', vegetal: [0,0,0,0,0], hidrogenado: [0,0,0,0,0] },
    { idSucursal: 39, sucursal: 'CALL CENTER 1', vegetal: [0,0,0,0,0], hidrogenado: [0,0,0,0,0] },
    { idSucursal: 1, sucursal: 'HUPER', vegetal: [0,0,0,0,0], hidrogenado: [0,0,0,0,0] },
    { idSucursal: 13, sucursal: 'SACABA', vegetal: [0,0,0,0,0], hidrogenado: [0,0,0,0,0] },
    { idSucursal: 21, sucursal: 'AMÉRICA', vegetal: [0,0,0,0,0], hidrogenado: [0,0,0,0,0] },
    { idSucursal: 11, sucursal: 'CALL CENTER 2', vegetal: [0,0,0,0,0], hidrogenado: [0,0,0,0,0] },
    { idSucursal: 7, sucursal: 'DUBAI', vegetal: [0,0,0,0,0], hidrogenado: [0,0,0,0,0] },
    { idSucursal: 4, sucursal: 'PERÚ', vegetal: [0,0,0,0,0], hidrogenado: [0,0,0,0,0] },
    { idSucursal: 5, sucursal: 'QUILLACOLLO', vegetal: [0,0,0,0,0], hidrogenado: [0,0,0,0,0] },
    { idSucursal: 26, sucursal: 'TIQUIPAYA', vegetal: [0,0,0,0,0], hidrogenado: [0,0,0,0,0] },
    { idSucursal: 29, sucursal: 'FEXCO', vegetal: [0,0,0,0,0], hidrogenado: [0,0,0,0,0] }
];

const sucursalesLunes = [2, 3, 6, 39, 1, 29, 13];

const sucursalesJueves = [5, 4, 7, 26, 21, 11];

const server = process.env.REACT_APP_SERVER;

const quincenales = ['TIQUIPAYA', 'HUPER', 'SACABA', 'DUBAI', 'FEXCO'];

const copiarDatos = () => datosIniciales.map(item => ({
    ...item,
    vegetal: [...item.vegetal],
    hidrogenado: [...item.hidrogenado],
    sobranteVegetal: Array(5).fill(null),
    sobranteHidrogenado: Array(5).fill(null)
}));

const sumar = valores =>
    valores.reduce((total, valor) => total + Number(valor || 0), 0);

function PedidoDeAceite() {
    const [mes, setMes] = useState(() => {
        const hoy = new Date();
        return `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}`;
    });

    const [listaSucursal, setListaSucursal] = useState(copiarDatos);
    const [validado, setValidado] = useState(false);

    const [cargando, setCargando] = useState(false);
    const [guardando, setGuardando] = useState(false);
    const [datosGuardados, setDatosGuardados] = useState(null);


    const [showModal, setShowModal] = useState(false);
    const tableRef = useRef(null);

    const fechasPedido = useMemo(() => {
        return obtenerFechasDelMes(mes);
    }, [mes]);

    const cantidadSemanas = useMemo(() => {
        const lunes = fechasPedido.filter(
            item => item.diaEntrega === 'LUNES'
        ).length;

        const jueves = fechasPedido.filter(
            item => item.diaEntrega === 'JUEVES'
        ).length;

        return lunes > 4 || jueves > 4 ? 5 : 4;
    }, [fechasPedido]);

    const semanas = useMemo(() => {
        return Array.from(
            { length: cantidadSemanas },
            (_, index) => index
        );
    }, [cantidadSemanas]);

    // Separar sucursales según día de entrega
    const listaLunes = listaSucursal.filter(item =>
        sucursalesLunes.includes(Number(item.idSucursal))
    );

    const listaJueves = listaSucursal.filter(item =>
        sucursalesJueves.includes(Number(item.idSucursal))
    );

    // Obtener las semanas correspondientes a cada grupo
    const fechasLunes = fechasPedido.filter(
        item => item.diaEntrega === 'LUNES'
    );

    const fechasJueves = fechasPedido.filter(
        item => item.diaEntrega === 'JUEVES'
    );

    const totales = useMemo(() => ({
        vegetal: listaSucursal.reduce(
            (total, item) =>
                total + semanas.reduce(
                    (suma, semana) =>
                        suma + Number(item.vegetal[semana] || 0),
                    0
                ),
            0
        ),

        hidrogenado: listaSucursal.reduce(
            (total, item) =>
                total + semanas.reduce(
                    (suma, semana) =>
                        suma + Number(item.hidrogenado[semana] || 0),
                    0
                ),
            0
        )
    }), [listaSucursal, semanas]);

    function cambiarCantidad(index, tipo, semana, valor) {

        if (cargando || guardando) return;

        if (valor !== '' && !/^\d+$/.test(valor)) return;

        const nuevaLista = listaSucursal.map((item, i) => {

            if (i !== index) return item;

            const cantidades = [...item[tipo]];

            cantidades[semana] = valor;

            return {
                ...item,
                [tipo]: cantidades
            };

        });

        setListaSucursal(nuevaLista);

        if (datosGuardados) {
            setValidado(
                JSON.stringify(nuevaLista) === JSON.stringify(datosGuardados)
            );
        } else {
            setValidado(false);
        }
    }

    async function validarPedido() {
        const infoUser = JSON.parse(
                localStorage.getItem('info') || '{}'
            );
        if (!mes) {
            alert('Seleccione un mes');
            return;
        }

        const response = await fetch(
            `${server}/almacen/guardarPedidoAceite`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional: infoUser.ID_REGIONAL_ACTUAL,
                    usuario: infoUser.ID_EMPLEADO,
                    mes: mes,
                    pedidoSolicitado: listaSucursal
                })
            }
);

const resultado = await response.json();

if (resultado.ok) {
    setValidado(true);
} else {
    MsgUtils.msgError(resultado.error);
}
    }

    function obtenerFechasDelMes(mesSeleccionado) {
        const [anio, mes] = mesSeleccionado.split('-').map(Number);

        const fechas = [];
        const diasDelMes = new Date(anio, mes, 0).getDate();

        let semanaLunes = 0;
        let semanaJueves = 0;

        for (let dia = 1; dia <= diasDelMes; dia++) {
            const fecha = new Date(anio, mes - 1, dia);
            const diaSemana = fecha.getDay();

            if (diaSemana === 1) {
                fechas.push({
                    fecha: `${String(dia).padStart(2, '0')}/${String(mes).padStart(2, '0')}/${anio}`,
                    diaEntrega: 'LUNES',
                    semana: semanaLunes++
                });
            }

            if (diaSemana === 4) {
                fechas.push({
                    fecha: `${String(dia).padStart(2, '0')}/${String(mes).padStart(2, '0')}/${anio}`,
                    diaEntrega: 'JUEVES',
                    semana: semanaJueves++
                });
            }
        }

        return fechas;
    }

   async function obtenerInventariosMensuales(mes) {

        const fechas = obtenerFechasDelMes(mes);

        const resultado = [];

        // Evitar consultar dos veces el mismo viernes
        const inventariosPorViernes = new Map();

        for (const item of fechas) {

            const {
                fecha,
                diaEntrega,
                semana
            } = item;

            // Obtener viernes anterior a la entrega
            const fechaInventario = obtenerViernesAnterior(fecha);

            const sucursalesPermitidas =
                diaEntrega === 'LUNES'
                    ? sucursalesLunes
                    : sucursalesJueves;

            let inventarios;

            if (inventariosPorViernes.has(fechaInventario)) {

                inventarios = inventariosPorViernes.get(fechaInventario);

            } else {

                inventarios = await consultarInventarioPorFecha(
                    fechaInventario
                );

                inventariosPorViernes.set(
                    fechaInventario,
                    inventarios
                );
            }

            for (const fila of inventarios) {

                const idSucursal = Number(fila.ID_SUCURSAL);

                if (!sucursalesPermitidas.includes(idSucursal)) {
                    continue;
                }

                resultado.push({
                    idSucursal,
                    idProducto: Number(fila.ID_PRODUCTO),
                    cantidad: Number(fila.CANTIDAD),
                    fechaEntrega: fecha,
                    fechaInventario,
                    diaEntrega,
                    semana
                });
            }
        }

        return resultado;
    }

    async function consultarInventarioPorFecha(fecha) {
        try {

            const infoUser = JSON.parse(
                    localStorage.getItem('info') || '{}'
                );
                
            const response = await fetch(
                `${server}/almacen/obtenerInventarioPorFechaAceite`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        fecha: fecha,
                        regional: infoUser.ID_REGIONAL_ACTUAL
                    })
                }
            );

            const data = await response.json();

            if (!response.ok || !data.success) {
                throw new Error(
                    data.mensaje || 'Error al obtener inventario'
                );
            }

            // Ajustar "datos" al nombre real del arreglo de tu API.
            if (!Array.isArray(data.inventarios)) {
                throw new Error('El backend no devolvió un arreglo de inventarios');
            }

            return data.inventarios;

        } catch (error) {
            console.error('Error al consultar inventario:', fecha, error);
            throw error;
        }
    }

    function obtenerViernesAnterior(fechaEntrega) {

            const [dia, mes, anio] = fechaEntrega.split('/').map(Number);

            const fecha = new Date(anio, mes - 1, dia);

            const diaSemana = fecha.getDay();

            // Viernes = 5
            const diasRestar = (diaSemana - 5 + 7) % 7 || 7;

            fecha.setDate(fecha.getDate() - diasRestar);

            const diaViernes = String(fecha.getDate()).padStart(2, '0');
            const mesViernes = String(fecha.getMonth() + 1).padStart(2, '0');
            const anioViernes = fecha.getFullYear();

            return `${diaViernes}/${mesViernes}/${anioViernes}`;
        }

    function organizarInventariosPorSemana(inventarios) {

        const sucursales = copiarDatos();

        for (const inventario of inventarios) {

            const {
                idSucursal,
                idProducto,
                cantidad,
                semana
            } = inventario;

            const sucursal = sucursales.find(
                item => Number(item.idSucursal) === Number(idSucursal)
            );

            if (!sucursal) continue;

            if (semana < 0 || semana >= 5) continue;

            let tipoAceite;
            let tipoSobrante;

            if (Number(idProducto) === 195) {
                tipoAceite = 'vegetal';
                tipoSobrante = 'sobranteVegetal';
            } else if (Number(idProducto) === 196) {
                tipoAceite = 'hidrogenado';
                tipoSobrante = 'sobranteHidrogenado';
            } else {
                continue;
            }

            const saldo = Number(cantidad) || 0;

            // Guardar el sobrante del viernes anterior
            sucursal[tipoSobrante][semana] = saldo;

            // Calcular cantidad a pedir
            let cantidadPedido = saldo > 250 ? 200 : 400;

            // Sucursales quincenales: solo semanas 1, 3 y 5
            if (quincenales.includes(sucursal.sucursal) && semana % 2 !== 0) {
                cantidadPedido = 0;
            }

            sucursal[tipoAceite][semana] = cantidadPedido;
        }

        return sucursales;
    }

    async function obtenerPedidoGuardado(mesSeleccionado) {
        const infoUser = JSON.parse(
                localStorage.getItem('info') || '{}'
            );
        const response = await fetch(
            `${server}/almacen/obtenerPedidoAceite`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional: infoUser.ID_REGIONAL_ACTUAL,
                    mes: mesSeleccionado
                })
            }
        );

        const resultado = await response.json();

        if (!response.ok || !resultado.ok) {
            throw new Error(
                resultado.error || 'Error al consultar el pedido'
            );
        }

        return resultado;
    }

    function organizarPedidoGuardado(pedidos) {

        const sucursales = copiarDatos();

        pedidos.forEach(item => {

            const sucursal = sucursales.find(
                s => Number(s.idSucursal) === Number(item.idSucursal)
            );

            if (!sucursal) return;

            const datos = typeof item.datos === 'string'
                ? JSON.parse(item.datos)
                : item.datos;

            if (Number(item.idProducto) === 195) {
                sucursal.vegetal = datos.pedidos;
                sucursal.sobranteVegetal = datos.sobrantes;
            }

            if (Number(item.idProducto) === 196) {
                sucursal.hidrogenado = datos.pedidos;
                sucursal.sobranteHidrogenado = datos.sobrantes;
            }

        });

        return sucursales;
    }

    function obtenerFechasSemana(semana) {

        const lunes = fechasPedido.find(
            item => item.semana === semana &&
                    item.diaEntrega === 'LUNES'
        );

        const jueves = fechasPedido.find(
            item => item.semana === semana &&
                    item.diaEntrega === 'JUEVES'
        );

        return {
            pedidoLunes: lunes?.fecha || '—',
            pedidoJueves: jueves?.fecha || '—',

            sobranteLunes: lunes
                ? obtenerViernesAnterior(lunes.fecha)
                : '—',

            sobranteJueves: jueves
                ? obtenerViernesAnterior(jueves.fecha)
                : '—'
        };
    }

    function renderizarTabla(titulo, sucursales, fechas) {

        return (
            <div className="mb-4">

                <h5 className="bg-dark text-white p-2 mb-0">
                    {titulo}
                </h5>

                <div className="table-responsive">

                    <table
                        className="table table-dark table-sm table-striped table-bordered align-middle mb-0"
                        style={{ minWidth: '850px' }}
                    >

                        <thead className="text-center align-middle">

                            <tr>
                                <th rowSpan="3">N.º</th>
                                <th rowSpan="3">SUCURSAL</th>

                                <th colSpan={fechas.length * 2}>
                                    ACEITE VEGETAL
                                </th>

                                <th rowSpan="3">TOTAL PEDIDO</th>
                            </tr>

                            <tr>
                                {fechas.map(item => (
                                    <th key={item.fecha} colSpan="2">
                                        SEMANA {item.semana + 1}
                                    </th>
                                ))}
                            </tr>

                            <tr>
                                {fechas.map(item => (
                                    <React.Fragment key={item.fecha}>

                                        {/* PRIMERO SOBRANTE */}
                                        <th>
                                            <div>Sobrante</div>
                                            <small className="text-warning">
                                                {obtenerViernesAnterior(item.fecha)}
                                            </small>
                                        </th>

                                        {/* DESPUÉS PEDIDO */}
                                        <th>
                                            <div>Pedido</div>
                                            <small className="text-info">
                                                {item.fecha}
                                            </small>
                                        </th>

                                    </React.Fragment>
                                ))}
                            </tr>

                        </thead>

                        <tbody>

                            {sucursales.map((item, index) => {

                                // Buscar índice real en listaSucursal
                                const indexOriginal = listaSucursal.findIndex(
                                    s => Number(s.idSucursal) === Number(item.idSucursal)
                                );

                                return (
                                    <tr key={item.idSucursal}>

                                        <td className="text-center">
                                            {index + 1}
                                        </td>

                                        <td className="fw-bold">
                                            {item.sucursal}

                                            {quincenales.includes(item.sucursal) && (
                                                <div className="small text-warning">
                                                    Ingreso quincenal
                                                </div>
                                            )}
                                        </td>

                                        {fechas.map(fecha => {

                                            const semana = fecha.semana;

                                            const sobrante =
                                                item.sobranteVegetal?.[semana];

                                            return (
                                                <React.Fragment key={fecha.fecha}>

                                                    {/* SOBRANTE */}
                                                    <td className="text-center align-middle">
                                                        <span className="fw-bold text-warning">
                                                            {sobrante !== null &&
                                                            sobrante !== undefined
                                                                ? `${sobrante} L`
                                                                : 'S/D'}
                                                        </span>
                                                    </td>

                                                    {/* PEDIDO */}
                                                    <td className="text-center">

                                                        <input
                                                            type="number"
                                                            min="0"
                                                            step="1"
                                                            className="form-control form-control-sm text-center mx-auto"
                                                            style={{ width: '85px' }}
                                                            value={item.vegetal[semana] ?? 0}
                                                            disabled={guardando || cargando}
                                                            onChange={e =>
                                                                cambiarCantidad(
                                                                    indexOriginal,
                                                                    'vegetal',
                                                                    semana,
                                                                    e.target.value
                                                                )
                                                            }
                                                        />

                                                    </td>

                                                </React.Fragment>
                                            );
                                        })}

                                        <td className="text-center fw-bold">
                                            {sumar(
                                                fechas.map(fecha =>
                                                    item.vegetal[fecha.semana] || 0
                                                )
                                            )}
                                        </td>

                                    </tr>
                                );
                            })}

                        </tbody>

                        <tfoot className="text-center fw-bold">

                            <tr>

                                <td colSpan="2">
                                    TOTAL ACEITE VEGETAL
                                </td>

                                {fechas.map(fecha => (
                                    <React.Fragment key={fecha.fecha}>

                                        <td>—</td>

                                        <td>
                                            {sucursales.reduce(
                                                (total, item) =>
                                                    total +
                                                    Number(item.vegetal[fecha.semana] || 0),
                                                0
                                            )}
                                        </td>

                                    </React.Fragment>
                                ))}

                                <td>
                                    {sucursales.reduce(
                                        (total, item) =>
                                            total + sumar(
                                                fechas.map(fecha =>
                                                    item.vegetal[fecha.semana] || 0
                                                )
                                            ),
                                        0
                                    )}
                                </td>

                            </tr>

                        </tfoot>

                    </table>

                </div>

            </div>
        );
    }

    function renderizarTablaGenerar(titulo, sucursales, fechas) {

        return (
            <div className="mb-4">

                <h6 className="bg-dark text-white p-2">
                    {titulo}
                </h6>

                <div className="table-responsive">

                    <table className="table table-sm table-bordered table-striped text-center align-middle">

                        <thead className="table-dark">
                            <tr>
                                <th>N.º</th>
                                <th>Sucursal</th>

                                {fechas.map(fecha => (
                                    <th key={fecha.fecha}>
                                        <div>
                                            Semana {fecha.semana + 1}
                                        </div>

                                        <small>
                                            {fecha.fecha}
                                        </small>
                                    </th>
                                ))}

                                <th>Total</th>
                            </tr>
                        </thead>

                        <tbody>
                            {sucursales.map((item, index) => (

                                <tr key={item.idSucursal}>

                                    <td>{index + 1}</td>

                                    <td className="text-start">
                                        {item.sucursal}
                                    </td>

                                    {fechas.map(fecha => (
                                        <td key={fecha.fecha}>
                                            {Number(
                                                item.vegetal[fecha.semana] || 0
                                            )}
                                        </td>
                                    ))}

                                    <td className="fw-bold">
                                        {sumar(
                                            fechas.map(fecha =>
                                                item.vegetal[fecha.semana] || 0
                                            )
                                        )}
                                    </td>

                                </tr>
                            ))}
                        </tbody>

                        <tfoot className="table-secondary fw-bold">
                            <tr>
                                <td colSpan="2">
                                    TOTAL
                                </td>

                                {fechas.map(fecha => (
                                    <td key={fecha.fecha}>
                                        {sucursales.reduce(
                                            (total, item) =>
                                                total + Number(
                                                    item.vegetal[fecha.semana] || 0
                                                ),
                                            0
                                        )}
                                    </td>
                                ))}

                                <td>
                                    {sucursales.reduce(
                                        (total, item) =>
                                            total + sumar(
                                                fechas.map(fecha =>
                                                    item.vegetal[fecha.semana] || 0
                                                )
                                            ),
                                        0
                                    )}
                                </td>
                            </tr>
                        </tfoot>

                    </table>

                </div>
            </div>
        );
    }

   useEffect(() => {
           const infoUser = JSON.parse(
                localStorage.getItem('info') || '{}'
            );
        if (!mes || !infoUser?.ID_REGIONAL_ACTUAL) return;

        let activo = true;

        async function cargarDatos() {

            try {

                setCargando(true);

                const resultado = await obtenerPedidoGuardado(mes);

                if (!activo) return;

                if (resultado.existe) {

                    const datos = organizarPedidoGuardado(resultado.pedidos);

                    setListaSucursal(datos);
                    setDatosGuardados(datos);
                    setValidado(true);

                } else {

                    const inventarios = await obtenerInventariosMensuales(mes);

                    if (!activo) return;

                    const datos = organizarInventariosPorSemana(inventarios);

                    setListaSucursal(datos);
                    setDatosGuardados(null);
                    setValidado(false);

                }

            } catch (error) {

                console.error('Error cargando pedidos:', error);

                if (activo) {
                    alert('No se pudieron cargar los pedidos del mes');
                }

            } finally {

                if (activo) {
                    setCargando(false);
                }

            }

        }

        cargarDatos();

        return () => {
            activo = false;
        };

    }, [mes]);

    return (
        <div className="container-fluid px-0">

            {/* CABECERA */}
            <div className="container-fluid bg-dark bg-gradient py-2">
                <div className="row gx-2 gy-2 align-items-center">

                    <div className="col-auto">
                        <span className="text-white fw-bold">
                            Pedido de Aceite
                        </span>
                    </div>

                    <div className="col-auto">
                        <div className="input-group input-group-sm">
                            <span className="input-group-text">Mes</span>
                            <input
                                type="month"
                                className="form-control"
                                value={mes}
                                disabled={guardando || cargando}
                                onChange={e => {
                                        if (guardando || cargando) return;

                                        setMes(e.target.value);
                                        setValidado(false);
                                        setDatosGuardados(null);
                                    }}
                            />
                        </div>
                    </div>

                    <div className="col-auto">
                        <button
                            className="btn btn-sm btn-secondary"
                            onClick={validarPedido}
                            disabled={validado || guardando || cargando || !mes}
                        >
                            <i className="fa-solid fa-check me-1"></i>

                            {guardando
                                ? 'Guardando...'
                                : validado
                                    ? 'Validado'
                                    : 'Validar'
                            }
                        </button>
                    </div>

                    <div className="col-auto">
                        <button
                            className="btn btn-sm btn-primary"
                            onClick={() => setShowModal(true)}
                        >
                            <i className="fa-solid fa-gears me-1"></i>
                            Generar
                        </button>
                    </div>

                    <div className="col-auto">
                        <DownloadTableExcel
                            filename={`PedidoAceite_${mes}`}
                            sheet="Pedido Aceite"
                            currentTableRef={tableRef.current}
                        >
                            <button className="btn btn-sm btn-success">
                                <i className="fa-solid fa-file-excel me-1"></i>
                                Excel
                            </button>
                        </DownloadTableExcel>
                    </div>
                </div>
            </div>

            <div className="p-3">
                <h5>Fechas de pedido del mes</h5>

                <div className="d-flex flex-wrap gap-2">
                    {fechasPedido.map(item => (
                        <span key={item.fecha} className="badge bg-primary p-2">
                            {item.diaEntrega} - {item.fecha}
                        </span>
                    ))}
                </div>
            </div>

            {/* TABLA EDITABLE */}
            {/* TABLA DE SUCURSALES CON ENTREGA LOS LUNES */}
            {renderizarTabla(
                'PEDIDOS DE ACEITE VEGETAL - LUNES',
                listaLunes,
                fechasLunes
            )}

            {/* TABLA DE SUCURSALES CON ENTREGA LOS JUEVES */}
            {renderizarTabla(
                'PEDIDOS DE ACEITE VEGETAL - JUEVES',
                listaJueves,
                fechasJueves
            )}

            <div className="p-2">
                <strong>NOTA IMPORTANTE:</strong> SUCURSALES DE INGRESO
                QUINCENAL: TIQUIPAYA, HUPER, SACABA, DUBAI Y FEXCO.
            </div>

            {/* TABLA PARA EXPORTAR A EXCEL */}
           <table ref={tableRef} style={{ display: 'none' }}>
                <thead>
                    <tr>
                        <th>Día de entrega</th>
                        <th>Sucursal</th>

                        {semanas.map(semana => (
                            <React.Fragment key={semana}>
                                <th>Semana {semana + 1} - Sobrante</th>
                                <th>Semana {semana + 1} - Pedido</th>
                            </React.Fragment>
                        ))}

                        <th>Total pedido</th>
                    </tr>
                </thead>

                <tbody>
                    {listaSucursal.map(item => {

                        const diaEntrega = sucursalesLunes.includes(
                            Number(item.idSucursal)
                        ) ? 'LUNES' : 'JUEVES';

                        return (
                            <tr key={item.idSucursal}>
                                <td>{diaEntrega}</td>
                                <td>{item.sucursal}</td>

                                {semanas.map(semana => (
                                    <React.Fragment key={semana}>
                                        <td>
                                            {item.sobranteVegetal?.[semana] ?? 'S/D'}
                                        </td>
                                        <td>
                                            {item.vegetal[semana] ?? 0}
                                        </td>
                                    </React.Fragment>
                                ))}

                                <td>{sumar(item.vegetal)}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>

            {/* MODAL GENERAR */}
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                size="xl"
                centered
                scrollable
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Generar Pedido de Aceite Vegetal
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    <div className="mb-3">
                        <strong>Mes:</strong> {mes}

                        <div>
                            <strong>Total de sucursales:</strong>{' '}
                            {listaSucursal.length}
                        </div>
                    </div>

                    {/* PEDIDOS DE LUNES */}
                    {renderizarTablaGenerar(
                        'PEDIDOS DE LOS LUNES',
                        listaLunes,
                        fechasLunes
                    )}

                    {/* PEDIDOS DE JUEVES */}
                    {renderizarTablaGenerar(
                        'PEDIDOS DE LOS JUEVES',
                        listaJueves,
                        fechasJueves
                    )}

                    <div className="text-end border-top pt-3">

                        <h5>
                            TOTAL GENERAL ACEITE VEGETAL:{' '}
                            <span className="text-primary">
                                {totales.vegetal} L
                            </span>
                        </h5>

                    </div>

                </Modal.Body>

                <Modal.Footer>
                    <button
                        className="btn btn-secondary"
                        onClick={() => setShowModal(false)}
                    >
                        Cerrar
                    </button>
                </Modal.Footer>
            </Modal>

        </div>
    );
}

export default PedidoDeAceite;